import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const Discover: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--discover')}
    viewBox="0 0 120 77.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g>
      <path
        d="M8.5 0C3.8 0 0 3.8 0 8.5v60.2c0 4.7 3.8 8.5 8.5 8.5h103.1c4.7 0 8.5-3.8 8.5-8.5V8.5c0-4.7-3.8-8.5-8.5-8.5H8.5z"
        fill="#4D4D4D"
      />
      <path
        d="M50.3 24.9c1.4 0 2.5.3 3.9.9v3.5c-1.3-1.2-2.5-1.7-4-1.7-3 0-5.3 2.3-5.3 5.2 0 3.1 2.3 5.3 5.4 5.3 1.4 0 2.6-.5 3.8-1.7V40c-1.4.6-2.6.9-4 .9-4.8 0-8.6-3.5-8.6-8 .2-4.4 4-8 8.8-8zm-14.9.1c1.8 0 3.4.6 4.8 1.7l-1.7 2c-.8-.9-1.6-1.2-2.5-1.2-1.4 0-2.4.7-2.4 1.7 0 .8.6 1.3 2.5 1.9 3.6 1.2 4.7 2.3 4.7 4.8 0 3-2.3 5-5.6 5-2.4 0-4.2-.9-5.6-2.9l2-1.9c.7 1.3 1.9 2 3.4 2 1.4 0 2.5-.9 2.5-2.2 0-.6-.3-1.2-.9-1.6-.3-.2-.9-.5-2.2-.9-3-1-4-2.1-4-4.2-.1-2.3 2.1-4.2 5-4.2zm36.1.3H75l4.3 10.2 4.4-10.2h3.4l-7 15.6h-1.7l-6.9-15.6zm-61.1 0H15c5.1 0 8.7 3.1 8.7 7.6 0 2.2-1.1 4.4-2.9 5.9-1.6 1.2-3.3 1.8-5.8 1.8h-4.6V25.3zm14.8 0h3.2v15.3h-3.2V25.3zm63.3 0h9v2.6h-5.8v3.4h5.6v2.6h-5.6V38h5.8v2.6h-9V25.3zm11.1 0h4.7c3.6 0 5.7 1.6 5.7 4.5 0 2.3-1.3 3.9-3.7 4.3l5.1 6.4h-3.9l-4.4-6.1h-.4v6.1h-3.2V25.3zm3.1 2.4v4.6h.9c2 0 3.1-.8 3.1-2.4 0-1.5-1.1-2.3-3-2.3 0 .1-1 .1-1 .1zm-89.2.2V38h.8c2 0 3.3-.4 4.3-1.2 1.1-.9 1.8-2.4 1.8-3.8 0-1.5-.7-2.9-1.8-3.8-1-.9-2.3-1.2-4.3-1.2.1-.1-.8-.1-.8-.1z"
        fill="#FFFFFF"
      />
      <path
        d="M63.9 24.8c4.8 0 8.6 3.6 8.6 8.1S68.6 41 63.9 41s-8.6-3.6-8.6-8.1c-.1-4.5 3.8-8.1 8.6-8.1zM120 44.4c-4 2.8-34 23-86 32.7h77.5c4.7 0 8.5-3.8 8.5-8.5V44.4z"
        fill="#F47216"
      />
    </g>
  </svg>
);

export default Discover;
